import React from "react";
//import "./styles.css";
import { Form } from "react-bootstrap";
// import LeftpanelAdmin from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import "./certificate-guide.css";
//import DataTable from "react-data-table-component";
import { Pdf } from "../../../../assets/images";

const CertificateGuide = () => {
  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelAdmin />
    <div className="right_cont">
      <div className="right_banner_banner_cnt">
        <div className="travel_deals_admin">
          <h2>Hello, Admin!</h2>
          <div className="text_field_partts">
            <div className="user_added resources_p">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Enter Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter title"
                  className="text_link"
                />
              </Form.Group>
              <div className="upload_pdf">
                <h3>Upload Pdf</h3>
                <div className="upload_btn_wrapper">
                  <button className="btn_bulk">
                    <span className="cert_bulkks">
                      <img src={Pdf} alt="" />
                    </span>
                    Upload Pdf
                  </button>
                  <input type="file" name="myfile" accept=".pdf" />
                </div>
              </div>

              <div className="sub_but">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    /* </div>
            </div> */
  );
};

export default CertificateGuide;
